<template lang="pug">
  #contract-chat-order
    template(v-if="isLoading === true")
      loading
    template(v-else)
      .d-flex
        b-card.mt-1.flex-grow-1(header-tag="header")
          contract-chat-form(v-model="value")
        contract-chat-price(v-model="value")
</template>

<script>
import ContractChatForm from "@/components/contractOrder/ContractChatForm";
import ContractChatPrice from "@/components/contractOrder/ContractChatPrice";
import Loading from "@/components/Loading";

import Api from '@/repositories/api';
const C206ContractInfo = Api.get('c206ContractInfo');
const S205ChatContractOrder = Api.get('s205ChatContractOrder');

export default {
  name: "ContractChatOrder",
  components: {
    ContractChatForm,
    ContractChatPrice,
    Loading,
  },
  props: {
    value: {type: Object, required: false}
  },
  data () {
    return {
      // ローディングフラグ
      isLoading: false,
    }
  },
  created() {
    // 読み込み中
    this.isLoading = true;

    // 既に契約番号が入力されている場合
    if (this.value.contract_no) {
      // 権限チェックを実行
      this.validateAuthority()
    }
    // 画面パラメータに契約番号が存在する場合
    else if ('contract_no' in this.$route.params) {
      // 権限チェックを実行
      this.validateAuthority()
      // 契約番号を設定
      this.value.contract_no = this.$route.params.contract_no
    }
    // 画面パラメータに契約番号が存在しない場合
    else {
      // C20601_契約情報取得処理を実行
      C206ContractInfo.get({contract_class: '5'})
        .then((response) => {
          // 取得した契約情報数が1件の場合
          if (response.data.data.length === 1) {
            // 権限チェックを実行
            this.validateAuthority()
            // 契約番号を設定
            this.value.contract_no = response.data.data[0].contract_no
          }
          else {
            // セッションストレージにデータを保存
            sessionStorage.setItem('contract_class', '5')
            sessionStorage.setItem('previous', 'ContractChatOrder')

            // S11500_ご契約環境選択画面に遷移
            this.$router.push({ name: 'ContractSelect' })
          }
        })
        .catch((error) => {
          // 共通のエラー処理
          this.apiError(error, '画面表示処理', "Support")

          // 画面TOPまでスクロールをする
          this.pageTopScroll()
        })
    }
  },
  methods: {
    /**
     * 権限チェックを行う
     */
    validateAuthority() {
      S205ChatContractOrder.view()
        .catch((err) => {
          // httpステータスコードが403の場合（権限エラー）
          if (err.response.status === 403) {
            // アプリケーションエラー画面へ遷移する
            this.$router.push({
              name: 'SupportApplicationError',
              params: {
                // 画面に表示するエラーメッセージ
                error_msg: this.forbidden_message
              }
            })
          }
        })
        .finally(() => {
          // ローディング終了
          this.isLoading = false
        })
    }
  },
}
</script>

<style scoped>
.next-icon {
  margin-top: 2px;
}
.image-size {
  width: 200px;
  height: 150px;
}
</style>